import type { FaireProductEntity } from "../../entity_types/product";

export const p_xgrdcxnwcu: FaireProductEntity = {
  token: "p_xgrdcxnwcu",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Mist",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/58be650ed786d3fca3e64c5f82abc450330a114ca7d0a5268e105b6e5d6fa101.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f70f893af9002868f9c1fb52732461d7dbaa1cc12a9abcdf682b0349cc1cfb62.jpeg",
    "https://cdn.faire.com/fastly/8c73af6f0ae370df67b68ae0d9af59c1aa54a66bb18c464844c1ee4ced2cba71.jpeg",
    "https://cdn.faire.com/fastly/70d6f41778d538d29539e63da3534ce68c483e819fbd239b119911cfebefadf9.jpeg",
    "https://cdn.faire.com/fastly/619ec5bce81693ddc7c55cd3103b613bdbab84eced4e6e40b5d46662ed389fc3.jpeg",
    "https://cdn.faire.com/fastly/74c1e272a77232a90d75f79af66d97b0b9d2e56b3fd73d5371daccabd6df2361.jpeg",
    "https://cdn.faire.com/fastly/1d7a4686784b2a839c2755cd76860df49facf7012951759a3b3d8ba2a5b35d35.jpeg",
    "https://cdn.faire.com/fastly/6b103a8b9ababa38bdff15ee7548b5dae5b3c3844a1f7c7f138cf6163afc294b.jpeg",
    "https://cdn.faire.com/fastly/12d7e6b87f2bc37e9e02ba6bb85ab61ea0bf6678e9fe9cbe93d54b3e2147e70b.jpeg",
    "https://cdn.faire.com/fastly/043c3b0e869eb336ca3190a7cf4cf26fb0fbb2abb3b6ded1e3fdbec14a4b64c6.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee—crafted from deadstock Pima cotton and designed with a bold jacquard knit. Lightweight, breathable, and easy to style, it’s a wardrobe essential.\n\n * Slightly cropped and boxy body \n * 100% Cotton \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:29.696Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
